import React, {useContext} from 'react';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import Layout from "./Layout";
import Page from "./Page";
import ErrorPage from "./pages/ErrorPage";
import HomePage from "./pages/HomePage";
import CommunityIndexPage from "./pages/CommunityIndexPage";
import NewsIndexPage from "./pages/NewsIndexPage";
import PelShop from "./pages/PelShop";
import TagPage from "./pages/TagPage";
import TournamentIndexPage from "./pages/TournamentIndexPage";
import TournamentPage from "./pages/TournamentPage";
import TournamentMatchPage from "./pages/TournamentMatchPage";
import TournamentTeamPage from "./pages/TournamentTeamPage";
import TournamentPlayerPage from "./pages/TournamentPlayerPage";
import ArticlePage from "./pages/ArticlePage";
import NewsPage from "./pages/NewsPage";
import UserModal from "./modals/UserModal";
import ViewUserModal from "./modals/ViewUserModal";
import ImageUploadModal from "./modals/ImageUploadModal";
import ViewCreatorModal from "./modals/ViewCreatorModal";
import SidebarPreviewPage from "./pages/SidebarPreviewPage";
import {AppContext} from "./AppContext";

class AppRoutes extends React.Component {
    constructor(props) {
        super(props);
        this.setRoutes();
    }

    setRoutes() {
        const router = createBrowserRouter([
            {
                path: "/",
                element: <Layout page={(<Page />)} />,
                errorElement: <Layout page={(<ErrorPage />)} />,
                children: [
                    {
                        index: true,
                        element: <HomePage />,
                    },
                    {
                        // Special page: combines all types that are trending
                        "path": "/yhteisö",
                        element: <CommunityIndexPage />,
                    },
                    {
                        // Special page: news index
                        "path": "/uutiset",
                        element: <NewsIndexPage />,
                    },
                    /*{
                        "path": "/pelaa",
                        element: <PlayPage index={true} />,
                    },*/
                    {
                        "path": "/kauppa",
                        element: <PelShop index={true} />,
                    },
                    {
                        "path": "/kauppa/:uri",
                        element: <PelShop />,
                    },
                    {
                        "path": "/kategoria/:uri",
                        element: <TagPage index={true} />,
                    },
                    /*{
                        "path": "/pelit",
                        element: <GamesPage index={true} />,
                    },
                    {
                        "path": "/pelit/:uri",
                        element: <GamesPage />,
                    },*/
                    /*{
                        "path": "/oppaat/:uri",
                        element: <GuidesPage />,
                    },
                    {
                        "path": "/oppaat",
                        element: <GuidesPage index={true} />,
                    },*/
                    {
                        "path": "/turnaukset",
                        element: <TournamentIndexPage msg="Turnaukset" />,
                    },
                    {
                        "path": "/turnaus/:uri",
                        element: <TournamentPage index={false} />,
                    },
                    {
                        "path": "/ottelu/:uri",
                        element: <TournamentMatchPage index={false} />,
                    },
                    {
                        "path": "/joukkue/:uri",
                        element: <TournamentTeamPage index={false} />,
                    },
                    {
                        "path": "/kilpapelaaja/:uri",
                        element: <TournamentPlayerPage index={false} />,
                    },
                    {
                        "path": "/yhteisöedut",
                        element: <ArticlePage uri="/yhteisöedut" index={false} />,
                    },
                    {
                        "path": "/bootcamp",
                        element: <ArticlePage uri="/bootcamp" index={false} />,
                    },
                    {
                        "path": "/saunatilat",
                        element: <ArticlePage uri="/saunatilat" index={false} />,
                    },
                    {
                        //<Route path="/modal/:id" element={<Modal />} />
                        "path": "/pelaaja",
                        element: <UserModal />,
                    },
                    {
                        "path": "/pelaaja/avatar",
                        element: <ImageUploadModal purpose="avatar" />,
                    },
                    {
                        "path": "/pelaaja/salasana",
                        element: <UserModal view="password" />,
                    },
                    {
                        "path": "/pelaaja/email",
                        element: <UserModal view="email" />,
                    },
                    {
                        "path": "/pelaaja/tiedot",
                        element: <UserModal view="info" />,
                    },
                    {
                        "path": "/pelaaja/käyttäjänimi",
                        element: <UserModal view="username" />,
                    },
                    {
                        "path": "/pelaaja/twitch",
                        element: <UserModal view="twitch" />,
                    },
                    {
                        "path": "/pelaaja/discord",
                        element: <UserModal view="discord" />,
                    },
                    {
                        "path": "/pelaaja/heippa",
                        element: <UserModal view="logged-out" />,
                    },
                    {
                        "path": "/pelaaja/kirjaudu",
                        element: <UserModal view="login-form" />,
                    },
                    {
                        "path": "/pelaaja/:id",
                        element: <ViewUserModal />,
                    },
                    {
                        "path": "/kirjoittaja/:id",
                        element: <ViewCreatorModal />,
                    },
                    /*{
                        "path": "/uutiset",
                        element: <NewsPage index={true} />,
                        // errorElement: <ErrorPage />, // @todo: ADD ONE
                    },*/
                    {
                        "path": "/uutiset/:uri",
                        element: <NewsPage />,
                        // errorElement: <ErrorPage />, // @todo: ADD ONE
                    },
                    {
                        "path": "/sidebar/:uri",
                        element: <SidebarPreviewPage />,
                    },
                    /*{
                        "path": "/tos",
                        element: <ToSPage />,
                    },*/
                    {
                        "path": "/:uri",
                        element: <ArticlePage index={false} />,
                    },
                ],
            },
            /*{
                path: "/foo",
                element: <Page state={this.state} />,
                //errorElement: <ErrorPage />,
            },*/
        ], {
            /*patchRoutesOnNavigation({ path, patch }) {
                console.error('DEBUG patchRoutesOnNavigation(), path=' + JSON.stringify(path)); // DEBUG
                //if (path.startsWith("/uutiset")) {
                if (path.includes("/uutiset/")) {
                    patch("uutiset", [
                        {
                            path: ":uri",
                            Component: NewsPage,
                        },
                    ]);
                }
            },*/
            "basename": (process.env.REACT_APP_BASE_URL || '/').replace(/\/$/, '')
        });
        this.router = (<RouterProvider router={router} fallbackElement={<Layout page={(<Page />)} />} />);
    }

    componentDidUpdate(prevProps, prevState) {
        this.setRoutes();
        /*if (this.props.context !== prevProps.context) {
            this.setRoutes();
        }*/
    }

    render() {
        return this.router;
    }
}

const AppRoutesWithContext = (props) => {
    const context = useContext(AppContext);
    return (<AppRoutes {...props} context={context} />);
};

export default AppRoutesWithContext;
